import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-extend-show',
  templateUrl: './extend-show.component.html',
  styleUrls: ['./extend-show.component.scss']
})
export class ExtendShowComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
